import React from 'react'

const AddButton = ({ buttonTitle, onclickDrawer, onClick, image ,className="" }) => {
    const handleClick = () => {
        if (onClick) {
            onClick();
        } else if (onclickDrawer) {
            onclickDrawer();
        }
    };

    return (
        <button className={`button bg-btn-primary hover:bg-primary text-white flex items-center rounded-[.375rem] gap-2 px-3 py-2 text-sm cursor-pointer add-btn ${className}`} onClick={handleClick} >
            {image && <img src={image} alt='add' />}
            <span>{buttonTitle}</span>
        </button>
    )
}

export default AddButton
